import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import group from "./index";
import functions from "../../utils/functionsFirebase";
import {ogFunctions} from "../../apis/og-functions/ogFunctionsApi";

function GroupReload() {

    const dispatch = useDispatch();

    const groups = useSelector(group.selectors.userGroups);

    useEffect(() => {

        const reloadUserGroup = async () => {
            const getPartialUserGroups = functions.httpsCallable('getPartialUserGroups');
            const res = await getPartialUserGroups();
            if (res.data.askedGroupIds.length !== groups?.askedGroups.length || res.data.groupIds.length !== groups?.groups.length
                || res.data.groupInvites.length !== groups?.groupInvites.length) {

                if (res.data.groupIds.length !== groups?.groups.length) {
                    const getUserGroups = ogFunctions.httpsCallable("getFullUserGroups");
                    getUserGroups().then(res => {
                        dispatch(group.actions.loadedGroups(res.data.groups, res.data.askedGroups, res.data.groupInvites));
                    });
                } else {
                    const commonGroups = groups.askedGroups.filter(x => res.data.askedGroupIds.indexOf(x) !== -1);
                    dispatch(group.actions.loadedGroups(groups.groups, commonGroups, res.data.groupInvites));
                }
            }
        }

        reloadUserGroup();

    }, [])

    return (<div></div>);
}

export default GroupReload;
